import { render, staticRenderFns } from "./InventoryDeleteItem.vue?vue&type=template&id=1e5ae2da&"
import script from "./InventoryDeleteItem.vue?vue&type=script&lang=ts&"
export * from "./InventoryDeleteItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports